<script>
export default {
  props: {
    item: {
      default: {}
    },
    itemDisponiveis: {
      default: {}
    },
    saveModalEquipeProjeto: {
      type: Function
    },
    closeModalEquipeProjeto: {
      type: Function
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="saveModalEquipeProjeto">
      <b-form-group
        class="col-md-12"
        id="input-group-1"
        label="Projeto"
        label-for="ProjetoId"
      >
        <b-form-select id="Projeto" v-model="item.id" required>
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in itemDisponiveis"
            :key="option.id"
            :value="option.id"
          >
            {{ option.denominacao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
      <div class="button-list float-right">
        <b-button class="btn btn btn-icon" variant="primary" type="submit"
          >Salvar</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="closeModalEquipeProjeto()"
          >Cancelar</b-button
        >
      </div>
    </b-form>
  </div>
</template>
